import { lazy, Suspense } from "react";
import "./index.css";
import { BrowserRouter, Routes, Route } from "react-router-dom";
import { Navbar } from "./components/sophitris/Navbar";
import { Footer } from "./components/sophitris/Footer";
import { ScrollToTop } from "./components/sophitris/ScrollToTop";
import { CookieConsent } from "./components/sophitris/CookieConsent";
import { WhatsAppButton } from "./components/sophitris/WhatsAppButton";
import { LanguageProvider } from "./utils/i18n";

const HomePage = lazy(() => import("./pages/sophitris/Home"));
const ExperienciasPage = lazy(() => import("./pages/sophitris/Experiencias"));
const OraculoPage = lazy(() => import("./pages/sophitris/OraculoOculto"));
const MesaRadionicaPage = lazy(() => import("./pages/sophitris/MesaRadionica"));
const KundaliniPage = lazy(() => import("./pages/sophitris/KundaliniPage"));
const RituaisPage = lazy(() => import("./pages/sophitris/Rituais"));
const SobrePage = lazy(() => import("./pages/sophitris/Sobre"));
const ContactosPage = lazy(() => import("./pages/sophitris/Contactos"));
const PrivacidadePage = lazy(() => import("./pages/sophitris/Privacidade"));
const CookiesPage = lazy(() => import("./pages/sophitris/Cookies"));
const TermosPage = lazy(() => import("./pages/sophitris/Termos"));
const TestemunhosPage = lazy(() => import("./pages/sophitris/Testemunhos"));
const AdminPanel = lazy(() => import("./pages/Admin").then(m => ({ default: m.AdminPanel })));

const Loader = () => (
  <div className="min-h-screen bg-[var(--black-deep)] flex items-center justify-center">
    <div className="text-[var(--gold)] text-xs tracking-[0.3em] uppercase animate-fade-in" style={{ fontFamily: "var(--font-body)" }}>
      SOPHITRIS
    </div>
  </div>
);

function App() {
  return (
    <LanguageProvider>
      <BrowserRouter>
        <ScrollToTop />
        <Navbar />
        <Suspense fallback={<Loader />}>
          <Routes>
            <Route path="/" element={<HomePage />} />
            <Route path="/experiencias" element={<ExperienciasPage />} />
            <Route path="/oraculo-oculto" element={<OraculoPage />} />
            <Route path="/mesa-radionica" element={<MesaRadionicaPage />} />
            <Route path="/kundalini" element={<KundaliniPage />} />
            <Route path="/rituais" element={<RituaisPage />} />
            <Route path="/sobre" element={<SobrePage />} />
            <Route path="/contactos" element={<ContactosPage />} />
            <Route path="/privacidade" element={<PrivacidadePage />} />
            <Route path="/cookies" element={<CookiesPage />} />
            <Route path="/termos" element={<TermosPage />} />
            <Route path="/testemunhos" element={<TestemunhosPage />} />
            <Route path="/admin" element={<AdminPanel />} />
            <Route path="*" element={
              <div className="bg-[var(--black-deep)] min-h-screen flex items-center justify-center">
                <div className="text-center px-6">
                  <p className="section-label mb-2">404</p>
                  <h1 className="text-3xl mb-6" style={{ fontFamily: "var(--font-heading)" }}>Pagina nao encontrada</h1>
                  <a href="/" className="btn-outline text-sm">Voltar ao Inicio</a>
                </div>
              </div>
            } />
          </Routes>
          <Footer />
        </Suspense>
        <CookieConsent />
        <WhatsAppButton />
      </BrowserRouter>
    </LanguageProvider>
  );
}

export default App;
